import { styled } from '@mui/system';
const SectionSubheading = styled('h3') `
  font-weight: 500;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey[400]};
  margin: 0px;
  margin-top: ${({ theme }) => theme.spacing(1)};
  grid-column: 1 / -1;
`;
export default SectionSubheading;
